import { useToast } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { FormEvent, useState } from 'react'
import writeXlsxFile, { Row, SheetData } from 'write-excel-file'
import { get } from '../../../lib/http'
import extractDataForm from '../../../utilities/extractDataForm'

import { DataForm, ReportDetailedProductSales } from './types'

export default function usePrintDetailedProductSales() {
    const toast = useToast()
    const [isLoading, setIsLoading] = useState(false)

    const head: (...values: string[]) => Row[number][] = (...values) =>
        values.map<Row[number]>(val => ({
            value: val,
            fontWeight: 'bold',
            wrap: true,
            alignVertical: 'center',
            align: 'left',
            fontSize: 11
        }))

    function setDetailedProductSales(
        data: ReportDetailedProductSales[],
        rows: SheetData
    ) {
        data.forEach(item => {
            rows.push([
                {
                    value: item.date,
                    type: String
                },
                {
                    value: item.code_receipt,
                    type: String
                },
                {
                    value: item.waiter_user,
                    type: String
                },
                {
                    value: item.category,
                    type: String
                },
                {
                    value: item.product,
                    type: String
                },
                {
                    value: item.quantity,
                    type: Number
                },
                {
                    value: item.price,
                    type: Number,
                    align: 'right',
                    format: '#,##0.00'
                },
                {
                    value: item.sale_amount,
                    type: Number,
                    align: 'right',
                    format: '#,##0.00'
                }
            ])
        })
    }

    async function submit(ev: FormEvent<HTMLFormElement>) {
        ev.preventDefault()
        const form = extractDataForm<DataForm>(ev.target)
        const startDate = dayjs
            .tz(form.startDate + ' 00:00:00', 'America/Lima')
            .toISOString()
        const endDate = dayjs
            .tz(form.endDate + ' 23:59:59', 'America/Lima')
            .toISOString()

        const rows: SheetData = [
            [],
            [
                {
                    value: 'Reporte de Ventas Detallada de Productos',
                    fontWeight: 'bold',
                    span: 8,
                    alignVertical: 'center',
                    align: 'center',
                    fontSize: 16
                }
            ],
            [
                {
                    value: `De: ${dayjs(startDate).format(
                        'DD/MM/YYYY'
                    )} - Hasta ${dayjs(endDate).format('DD/MM/YYYY')}`,
                    span: 8,
                    align: 'center'
                }
            ],
            [],
            head(
                ...[
                    'Fecha y Hora',
                    'Comprobante',
                    'Meser@',
                    'Categoría',
                    'Producto',
                    'Cantidad',
                    'Precio (S/)',
                    'Venta (S/)'
                ]
            )
        ]

        setIsLoading(true)

        const { data, error } = await get<ReportDetailedProductSales[]>(
            `/api/reports/detailed_product_sales?start_date=${startDate}&end_date=${endDate}`
        )

        if (error) {
            toast({
                title: 'Hubo un error al cargar los datos',
                status: 'error',
                position: 'top'
            })
            return
        }

        setDetailedProductSales(data.result, rows)

        await writeXlsxFile(rows, {
            fileName: `Reporte_de_ventas_detallada_de_producto_${dayjs(
                startDate
            ).format('DD/MM/YYYY')}_${dayjs(endDate).format(
                'DD/MM/YYYY'
            )}.xlsx`,
            columns: [25, 15, 20, 25, 30, 15, 20, 20].map(width => ({
                width
            })),
            fontSize: 10,
            fontFamily: 'Calibri'
        })

        setIsLoading(false)
    }

    return {
        submit,
        isLoading
    }
}
